import { RegisterUserPayload } from '../models/commonModels';
import fetch from './fetch';

export default (payload: RegisterUserPayload): Promise<void> =>
    fetch<void>('/register', {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const resendVerificationCode = ({ email }: { email: string }): Promise<void> =>
    fetch<void>('/resend-registration-confirmation', {
        method: 'POST',
        body: JSON.stringify({
            email,
        }),
    });

export const verifyEmail = ({ email, confirmationCode }: { email: string; confirmationCode: string }): Promise<void> =>
    fetch<void>('/confirm', {
        method: 'POST',
        body: JSON.stringify({
            email,
            confirmationCode,
        }),
    });
